import { useMemo } from 'react';
import { useSnowplowBulkContextRegistration } from '@mindtickle/snowplow-client';

export const useBaseContexts = () => {
  const contexts = useMemo(() => [], []);
  useSnowplowBulkContextRegistration(contexts);
  return contexts;
};

export default useBaseContexts;
